import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterContentInit, Component, ElementRef, EventEmitter, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Project, ProjectNew, ProjectType } from '../../models/models.lib';
import { FormModes, PHONE_REGEX } from '../../common/constants.lib';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../shared/logger.service';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';
import {NumberFormatOptions} from '@progress/kendo-angular-intl';

@Component({
  selector: 'casi-project',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    LayoutModule,
    AutoFocusDirective
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './project.component.html',
  styleUrl: './project.component.scss'
})
export class ProjectComponent implements OnInit, OnDestroy, AfterContentInit {

  @Input({ required: true }) project: ProjectType = new ProjectNew();
  @Input({ required: true }) mode: FormModes = FormModes.NOTSET;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  form: FormGroup;
  @ViewChild('pForm') pForm!: ElementRef;

  public formatOptions: NumberFormatOptions = {
    style: 'currency',
    currency: 'AU',
    currencyDisplay: 'name'
  }

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    private fb: FormBuilder,
    private scroller: ViewportScroller
  ) {
    this.form = this.fb.group(
      {
        project_name: [null, [Validators.required]],
        contact_person: [null, []],
        contact_email: [null, [Validators.email]],
        contact_telephone: [null, [Validators.pattern(PHONE_REGEX)]],
        funding_body: [null, []],
        project_amount: [null, []],
        development_amount: [null, []],
        dev_url: [null, []],
        uat_url: [null, []],
        prod_url: [null, []],
        postgresql_ver: [null, []],
        active_user_stories: [null, []],
        active_db_manager: [null, []]
      }
    );

  }

  //#region Form Properties

  get f() {
    return this.form.controls;
  }
  get project_name() {
    return this.form.get('project_name');
  }
  get contact_person() {
    return this.form.get('contact_person');
  }
  get contact_email() {
    return this.form.get('contact_email');
  }
  get contact_telephone() {
    return this.form.get('contact_telephone');
  }
  get funding_body() {
    return this.form.get('funding_body');
  }
  get project_amount() {
    return this.form.get('project_amount');
  }
  get development_amount() {
    return this.form.get('development_amount');
  }
  get dev_url() {
    return this.form.get('dev_url');
  }
  get uat_url() {
    return this.form.get('uat_url');
  }
  get prod_url() {
    return this.form.get('prod_url');
  }
  get postgresql_ver() {
    return this.form.get('postgresql_ver');
  }
  get active_user_stories() {
    return this.form.get('active_user_stories');
  }
  get active_db_manager() {
    return this.form.get('active_db_manager');
  }

  //#endregion

  //#region Event Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...',);
    this.form.patchValue(this.project);
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
    // this.scroller.scrollToPosition([10, 10]);
    setTimeout(() => {
      // document.body.scrollTo({ top: 0, behavior: 'smooth' });
      this.scroller.scrollToPosition([0, 0]);
      // this.pForm.nativeElement.scrollTop();
    }, 50);
  }

  onSubmit(): void {
    this.logger.debug(`onSubmit...`, this.form.value, this.mode);
    let toSave = { ...this.project, ...this.form.value };

    this.logger.debug(`onSubmit:toSave: `, toSave);

    this.onSave.emit({
      action: "save",
      data: toSave,
      mode: this.mode
    });
  }

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.onCancel.emit();
  }

  //#endregion

}
